import { differenceInDays, formatDistanceToNow } from 'date-fns';
import { enCA, fr } from 'date-fns/locale';
export const formatDateForNotificationCard = (date, language) => {
    if (!date || Array.isArray(date)) {
        return '';
    }
    const isOlderThanWeek = differenceInDays(new Date(), new Date(date)) >= 7;
    return isOlderThanWeek
        ? new Date(date).toLocaleDateString(`${language}-ca`, {
            day: 'numeric',
            year: 'numeric',
            month: 'short',
        })
        : formatDistanceToNow(new Date(date), {
            addSuffix: true,
            includeSeconds: true,
            locale: language === 'en' ? enCA : fr,
        });
};
export const getTimeOfDayGreetings = () => {
    const data = [
        [18, 'TITLE_EVENING', 'evening-icon'],
        [12, 'TITLE_AFTERNOON', 'sunrise-icon'],
        [0, 'TITLE_MORNING', 'sunrise-icon'],
    ], hr = new Date().getHours();
    const found = data.find((item) => hr >= Number(item[0])) || [];
    return [found[1], found[2]];
};
export const getCurrentDateInEST = () => {
    const date = new Date();
    // Get the current timezone offset in minutes
    const timezoneOffset = date.getTimezoneOffset();
    // Convert the offset to milliseconds and subtract from the date
    const tzString = date.toLocaleDateString('en-CA', {
        timeZone: 'America/Toronto',
        timeZoneName: 'short',
    });
    let estOffset = -5 * 60 * 60 * 1000; // Eastern Standard Time (EST) offset is UTC-5
    if (tzString.includes('EDT')) {
        estOffset = -4 * 60 * 60 * 1000; // Eastern Daylight Time (EDT) offset is UTC-4
    }
    const estTime = new Date(date.getTime() + timezoneOffset * 60 * 1000 + estOffset);
    return new Date(estTime);
};
